import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tag, Table } from 'antd';
import { get, toUpper } from 'lodash';
import { SeismicAction } from '~/actions';
import { ContentSection } from '~/components';
import { H1Title, H3Title } from '~/containers/styles';
import ContentData from '~/hoc/ContentData';

class SeismicEvent extends Component {
  state = {
    page: 1,
  };

  UNSAFE_componentWillMount() {
    this.props.loadSeicmiEvent(this.state.page);
  }

  changePage = (page) => {
    this.setState({ page }, () => {
      this.props.loadSeicmiEvent({ page });
    });
  };

  prepareData = ({ event, station }) => {
    if (event.data.length === 0) {
      return false;
    }

    const { profile } = this.props;

    const columns = [
      {
        title: 'วันและเวลาที่เกิดเหตุ',
        dataIndex: 'eventDate',
        key: 'eventDate',
      },
      {
        title: 'ค่า G สูงสุด',
        key: 'maxG',
        render: (text, record) => (
          <Tag color={record.isAlert ? 'red' : 'orange'}>{record.maxG}</Tag>
        ),
      },
    ];

    if (!!station) {
      Object.keys(station).forEach((stationId) => {
        columns.push({
          title: get(profile, `seismic.remap_station_name.${stationId}`, toUpper(stationId)),
          key: stationId,
          width: 80,
          render: (text, record) => (
            <NavLink
              title={station[stationId]}
              className="btn btn-default"
              to={`/seismic/station/${stationId}/m/${record.date.format('YYYY-MM-DD[T]HH:mm:ss')}`}
            >
              {get(profile, `seismic.remap_station_name.${stationId}`, toUpper(stationId))}
            </NavLink>
          ),
        });
      });
    }

    const dataSource = event.data.reduce((result, item) => {
      const currentItem = {
        eventDate: item.timestamp.format('LL เวลา LTS'),
        date: item.timestamp,
        key: item.timestamp.unix(),
        rowKey: item.timestamp.unix(),
        maxG: Number(item.g).toFixed(5),
        isAlert: item.alert,
      };

      result.push(currentItem);
      return result;
    }, []);

    return {
      columns,
      dataSource,
      pagination: {
        pageSize: event.pagination.perPage,
        total: event.pagination.totalData,
        onChange: this.changePage,
        current: this.state.page,
      },
    };
  };

  render() {
    const {
      profile: {
        seismic: { station },
      },
      seismic: {
        threshold: { alert, log },
        event,
      },
    } = this.props;

    const tableData = this.prepareData({ event, station });

    return (
      <ContentSection>
        <Helmet>
          <title>ประมวลเหตุการณ์แรงสั่นสะเทือนที่ผ่านมา</title>
        </Helmet>

        <ContentData
          title="ประมวลผลเหตุการณ์แรงสั่นสะเทือน"
          isLoading={event.pagination.totalData === -1}
        >
          <div className="row">
            <div className="col-xs-12">
              <H1Title>ประมวลเหตุการณ์แรงสั่นสะเทือนที่ผ่านมา</H1Title>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <div className="jumbotron">
                ระบบจัดเก็บค่าแรงสั่นสะเทือนที่มีความเร่งในหน่วย G โดยระบบจะเริ่มเก็บข้อมูลตั้งแต่{' '}
                <Tag color="orange">{`${log}G.`}</Tag>และจะมีการแจ้งเตือนเมื่อค่า G. มากกว่า{' '}
                <Tag color="red">{`${alert}G.`}</Tag>
              </div>
            </div>
          </div>

          {event.pagination.totalData === 0 && (
            <H3Title className="text-center">ไม่พบข้อมูลในระบบ</H3Title>
          )}

          {tableData && <Table {...tableData} />}
        </ContentData>
      </ContentSection>
    );
  }
}

export default connect(
  (state) => ({
    profile: state.DamProfile,
    seismic: state.Seismic,
  }),
  {
    loadSeicmiEvent: SeismicAction.getSeismicEvent,
  },
)(SeismicEvent);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicEvent/SeismicEvent.js